/**
 * A URL someone typed. People enter bare hostnames; the contract wants a real
 * URL, so the scheme is recognised here and supplied when it is absent, rather
 * than bouncing the input back at them.
 */
const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

export function withScheme(raw: string, fallbackScheme = "https"): string {
  const trimmed = raw.trim();
  return SCHEME.test(trimmed) ? trimmed : `${fallbackScheme}://${trimmed}`;
}
